import axios from "axios";
import React, { useEffect, useState } from "react";
import { getHeader } from "../../../service/auth";
import { useLocation } from "react-router-dom";
import TransferList from "../../../components/TransfertList";
import SnackAlert from "../../../components/SnackAlert";

const AssocQuestionnaire = () => {
  const headers = getHeader();
  const { state } = useLocation();
  const [disponible, setDisponible] = useState([]);
  const [selected, setSelected] = useState([]);
  const [alert, setAlert] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlert(false);
  };

  useEffect(() => {
    axios
    .get(process.env.REACT_APP_ADMIN+'/questionnaire/user/' + state.id, { headers })
    .then(({data}) => {
        
        setSelected(data);
    })
    .catch((err) => {
        setAlert(true);
    });

    axios
      .get(process.env.REACT_APP_ADMIN+'/questionnaire' , { headers })
      .then(({data}) => {
        setDisponible(data);
      })
      .catch((err) => {
        setAlert(true);
      });
    
  }, []);

  return (
    <>
      <TransferList disponible={disponible} selected={selected} id ={state.id} link={process.env.REACT_APP_ADMIN+"/user/assoc"} retour={'gestion_user'} />
      <SnackAlert
        open={alert}
        severity="error"
        message="Une erreur s'est produite"
        handleClose={handleClose}
      />
    </>
  );
};

export default AssocQuestionnaire;
